export type WordsListType = {
  name: string;
};
export type VadModalsChildrenType = {
  inputText: { id: string; labelTitle: string; placeholder: string }[];
  radioButtons: { labelTitle: string; radioBut: { id: string; value: string; label: string }[] }[];
  inputNumber: { labelTitle: string; id: string }[];
  inputNumberChat: { labelTitle: string; id: string }[];
};
export const colorsArray = [
  { color: 'FFFFFF' },
  { color: '3BA86D' },
  { color: '05C95F' },
  { color: '13DCDC' },
  { color: '2ECCEF' },
  { color: 'A96640' },
  { color: 'DA7B45' },
  { color: 'FF9B04' },
  { color: '972EE9' },
  { color: '2C62B4' },
  { color: 'E061B2' },
  { color: 'E80000' },
  { color: 'E92E5D' },
  { color: 'F06275' },
  { color: '182320' },
];
export const wordsListArray: string[] = [];
